import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import { REQUIRED } from "./validation";

export function fixInputClasses() {
  document.querySelectorAll("input,textarea,select").forEach((element) => {
    const input = element as HTMLElement;
    input.classList.add(input.matches(REQUIRED) ? "mr-0" : "mr-4");
  });
}

export function addCountries() {
  const countryData = intlTelInput
    .getCountryData()
    .filter(({ iso2 }) => iso2.toLowerCase() !== "ua");
  document
    .querySelectorAll("select[name=your-citizenship i]")
    .forEach((element) => {
      const countrySelect = element as HTMLSelectElement;
      countrySelect.children[0].textContent = "—Choose an option—";
      countryData.forEach(({ name }) => {
        const option = document.createElement("option");
        option.value = name;
        option.textContent = name;
        countrySelect.appendChild(option);
      });
    });
}

export function fixRadio() {
  const containers = [
    ...document.querySelectorAll(".wpcf7-radio"),
  ] as HTMLElement[];

  containers.forEach((container) => {
    const input = container.querySelector("input")! as HTMLInputElement;
    container.className = "grid grid-flow-col auto-cols-fr w-full gap-2";
    // All radios are required
    container.classList.add("mr-0");

    const groups = [
      ...container.querySelectorAll(".wpcf7-list-item"),
    ] as HTMLElement[];
    groups.forEach((group) => {
      const input = group.querySelector("input")! as HTMLInputElement;
      input.className = "peer hidden";

      const label = group.querySelector(
        ".wpcf7-list-item-label",
      )! as HTMLElement;
      label.className =
        "flex p-4 items-center cursor-pointer justify-center bg-neutral-900 text-white peer-checked:bg-white peer-checked:text-neutral-900";

      // Make label work
      const newGroup = document.createElement("label");
      group.insertAdjacentElement("beforebegin", newGroup);
      while (group.firstChild) {
        newGroup.appendChild(group.firstChild);
      }
      group.remove();
    });
  });
}

export function fixCheckboxes() {
  const checkboxes = [
    ...document.querySelectorAll("input[type=checkbox]"),
  ] as HTMLInputElement[];
  checkboxes.forEach((checkbox) => {
    const originalWrapper = checkbox.closest(
      ".wpcf7-form-control-wrap",
    ) as HTMLElement | null;
    if (!originalWrapper) {
      return;
    }

    const oldLabel = originalWrapper.querySelector(
      ".wpcf7-list-item-label",
    )! as HTMLElement;
    const svg = originalWrapper.querySelector("svg") as SVGElement | null;

    const parent = checkbox.closest(".flex.flex-col") as HTMLElement;
    const row = document.createElement("div");
    row.className = "flex flex-row";

    const label = document.createElement("label");
    const labelText = document.createElement("span");
    labelText.className = "w-full";
    labelText.textContent = oldLabel.textContent;

    label.className =
      "flex flex-row font-para text-base/tight font-semibold text-white";
    checkbox.className = "form-checkbox bg-neutral-950 checked:text-white";
    label.append(labelText, checkbox);

    row.append(label);
    if (svg) {
      row.append(svg);
    }
    parent.replaceChildren(row);
  });
}

export function fixSubmits() {
  const submits = [
    ...document.querySelectorAll("input[type=submit]"),
  ] as HTMLInputElement[];

  const template = document.querySelector(
    "#submit-template",
  )! as HTMLTemplateElement;

  submits.forEach((submit) => {
    const parent = submit.parentNode! as HTMLElement;
    parent.insertBefore(template.content.cloneNode(true), submit);
    submit.remove();
  });
}
